import { render } from "./TargetAudienceBlock.vue?vue&type=template&id=d6af5bd2"
import script from "./TargetAudienceBlock.vue?vue&type=script&lang=js"
export * from "./TargetAudienceBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/TargetAudienceBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6af5bd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6af5bd2', __exports__)) {
    api.reload('d6af5bd2', __exports__)
  }
  
  module.hot.accept("./TargetAudienceBlock.vue?vue&type=template&id=d6af5bd2", () => {
    api.rerender('d6af5bd2', render)
  })

}


export default __exports__